import { createStyles } from "@material-ui/core";
import { getTheme } from "../Themes";

const theme = getTheme()

export default createStyles({
  appBar: {
    left: theme.Adtrack.dimensions.drawerWidth,
    backgroundColor: theme.palette.background.default,
    height: theme.Adtrack.dimensions.appBarHeight,
    position: 'fixed',
    padding: 0,
    zIndex: theme.zIndex.drawer - 1,
    width: `calc(100% - ${theme.Adtrack.dimensions.drawerWidth}px)`,
    '& >.MuiToolbar-regular': {
      minHeight: '50px',
    },
  },
  appBarFull: {
    left: 0,
    backgroundColor: theme.palette.background.default,
    height: theme.Adtrack.dimensions.appBarHeight,
    position: 'fixed',
    padding: 0,
    zIndex: theme.zIndex.drawer - 1,
    '& >.MuiToolbar-regular': {
      minHeight: '50px',
    },
  },
  toolbar: {
    padding: theme.spacing(1),
  },
  barTitle: {
    color: 'inherit',
  },
  language: {
    color: theme.palette.text.primary,
  },
  logo: {
    width: '100%',
  },
  menuItems: {
    display: 'block',
    flexGrow: 1,
  },
  menus: {
    display: 'inline-flex',
    flexFlow: 'column',
    flexWrap: 'wrap',
  },
  logoStyle: {
    padding: 0,
    fontWeight: 500,
  },
  profileStyle: {
    padding: 0,
    color: theme.palette.text.primary,
  },
  selectCountry: {
    display: 'block',
    textAlign: 'end',
    '& select': {
      textTransform: 'capitalize',
    },
  },
  tabItem: {
    '&:hover': {
      color: theme.palette.text.secondary,
    },
    color: theme.palette.text.primary,
    opacity: 0.7,
    transition: theme.transitions.create('color'),
    minHeight: '38px',
    minWidth: '60px',
    '& >.MuiTab-root': {
      minWidth: '0px',
    },
  },
  tabs: {
    marginLeft: 0,
    width: '100%',
    minHeight: '38px',
  },
  tabsIndicator: {
    background: 'none',
  },
  userMenuContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
});